<template>
  <nav>
    <ul class="pagination">
      <li v-if="modelValue > 0" class="page-item">
        <button
          class="page-link"
          @click="$emit('update:modelValue', modelValue - 1)"
        >
          Previous
        </button>
      </li>

      <li
        v-for="page in count"
        :key="page"
        :class="modelValue === page - 1 ? 'page-item active' : 'page-item'"
      >
        <button class="page-link" @click="$emit('update:modelValue', page - 1)">
          {{ page }}
        </button>
      </li>

      <li v-if="modelValue < count - 1" class="page-item">
        <button
          class="page-link"
          @click="$emit('update:modelValue', modelValue + 1)"
        >
          Next
        </button>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
defineProps<{
  count: number;
  modelValue: number;
}>();
defineEmits<{
  (e: "update:modelValue", v: number): void;
}>();
</script>
